import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';
import toast from 'react-hot-toast';
import DashboardLayout from '../../components/layout/DashboardLayout';

const Dashboard: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [isCheckingProfile, setIsCheckingProfile] = useState(true);

  useEffect(() => {
    const checkUserProfile = async () => {
      console.log('Dashboard - checking user profile');
      setIsCheckingProfile(true);
      
      try {
        // Check if we have a session but no user profile
        const { data } = await supabase.auth.getSession();
        if (data.session && !user) {
          console.log('Dashboard - session exists but no user profile, redirecting to troubleshooting');
          navigate('/auth/troubleshoot');
          return;
        }
        
        // Check if user has organizations
        if (user && (!user.organizations || user.organizations.length === 0)) {
          console.log('Dashboard - user has no organizations, showing warning');
          toast.error('Your account is not associated with any organization', {
            duration: 5000
          });
        }
      } catch (error) {
        console.error('Error checking user profile:', error);
      } finally {
        setIsCheckingProfile(false);
      }
    };
    
    checkUserProfile();
  }, [user, navigate, isAuthenticated]);

  if (isCheckingProfile) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <Loader2 className="h-12 w-12 text-primary animate-spin mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Loading your dashboard...
          </h2>
          <p className="text-gray-600">
            Please wait while we prepare your experience.
          </p>
        </div>
      </div>
    );
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default Dashboard;